module.exports = __webpack_public_path__ + "img/image_6.89a627f3.png";